export default "__VITE_ASSET__B2S0kWDq__"